'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const handlerHelper = require('../../utils/handlerHelper.js');
const button_types = require('../Button/button.types.js');
const button = require('../Button/button.js');
const buttonGroup_style = require('./buttonGroup.style.js');
const useControlledState = require('../hooks/useControlledState/useControlledState.js');

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["data", "ariaLabel", "buttonGroupID", "buttonWrapperProps", "dataAttr", "defaultSelected", "handlers", "inline", "multiple", "overflow", "selected", "selectedStyleName"],
  _excluded2 = ["onClick"],
  _excluded3 = ["dataAttr"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
var PILL = button_types.ButtonShapes.PILL;
var DEFAULT = button_types.ButtonStyles.DEFAULT,
  LINK_BLUE = button_types.ButtonStyles.LINK_BLUE;
var DEFAULT_DATA_ATTR = {
  'data-testid': 'button-group'
};
var ButtonWrapper = styled__default.h2.withConfig({
  displayName: "buttonGroup__ButtonWrapper",
  componentId: "sc-wpwro6-0"
})([""]);
var ButtonGroup = function ButtonGroup(_ref) {
  var data = _ref.data,
    _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? '' : _ref$ariaLabel,
    buttonGroupID = _ref.buttonGroupID,
    buttonWrapperProps = _ref.buttonWrapperProps,
    _ref$dataAttr = _ref.dataAttr,
    dataAttr = _ref$dataAttr === void 0 ? {} : _ref$dataAttr,
    _ref$defaultSelected = _ref.defaultSelected,
    defaultSelected = _ref$defaultSelected === void 0 ? 0 : _ref$defaultSelected,
    _ref$handlers = _ref.handlers,
    handlers = _ref$handlers === void 0 ? {} : _ref$handlers,
    _ref$inline = _ref.inline,
    inline = _ref$inline === void 0 ? true : _ref$inline,
    multiple = _ref.multiple,
    overflow = _ref.overflow,
    selected = _ref.selected,
    _ref$selectedStyleNam = _ref.selectedStyleName,
    selectedStyleName = _ref$selectedStyleNam === void 0 ? LINK_BLUE : _ref$selectedStyleNam,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  // give user ability to make this fully controlled or uncontrolled based on requirements
  var _useControlledState = useControlledState({
      controlled: selected !== undefined ? Array.isArray(selected) ? selected : [selected] : undefined,
      "default": Array.isArray(defaultSelected) ? defaultSelected : [defaultSelected],
      name: 'ButtonGroup'
    }),
    _useControlledState2 = _slicedToArray(_useControlledState, 2),
    selectedState = _useControlledState2[0],
    setSelectedState = _useControlledState2[1];
  var _onClick = handlers.onClick,
    otherHandlers = _objectWithoutProperties(handlers, _excluded2);
  var changeHandler = {
    onClick: function onClick(e) {
      var target = e && e.currentTarget;
      var selectedIndex = target && target.getAttribute('data-index');
      var event;
      if (selectedIndex) {
        var selectedArr;
        // coerce to a number since it will be a string off the html element
        var numericalSelectedIndex = +selectedIndex;
        if (multiple) {
          var isSelected = selectedState.indexOf(numericalSelectedIndex);
          // not selected needs to be added
          if (isSelected === -1) {
            selectedArr = [].concat(_toConsumableArray(selectedState), [numericalSelectedIndex]);
            event = 'select-option';
          } else {
            // is selected already needs to be removed from selected arr
            selectedArr = _toConsumableArray(selectedState);
            selectedArr.splice(isSelected, 1);
            event = 'deselect-option';
          }
        } else {
          selectedArr = [numericalSelectedIndex];
          event = 'select-option';
        }
        setSelectedState(selectedArr);

        // if there is a custom onClick passed in fire it here
        // using same return syntax as dropdown, but adding nativeEvent + elementId too
        // event prop seems arbitrary, but doesn't hurt to pass along
        if (_onClick) {
          _onClick({
            selected: selectedArr,
            changes: data[selectedIndex],
            elementId: buttonGroupID,
            event: event,
            nativeEvent: e
          });
        }
      }
    }
  };
  var combinedDataAttr = _objectSpread(_objectSpread({}, DEFAULT_DATA_ATTR), dataAttr);
  var combinedHandlers = handlerHelper(null, otherHandlers, changeHandler);
  var buttonGroupButtons = data.map(function (button$1, i) {
    var dataAttr = button$1.dataAttr,
      restButtonProps = _objectWithoutProperties(button$1, _excluded3);
    var selected = selectedState.indexOf(i) !== -1;
    var ariaLabelText = ariaLabel || button$1.label || '';
    var defaultDataAttr = {
      'data-index': i,
      'data-selected': selected,
      'data-testid': "button--".concat(i)
    };
    var combinedDataAttr = _objectSpread(_objectSpread({}, defaultDataAttr), dataAttr);
    var ButtonComponent = function ButtonComponent() {
      return /*#__PURE__*/React__default.createElement(button, _extends({
        handlers: combinedHandlers,
        dataAttr: combinedDataAttr,
        ariaLabel: "".concat(ariaLabelText).concat(selected ? (ariaLabelText ? ' ' : '') + 'selected' : ''),
        ariaPressed: selected,
        shape: PILL,
        styleName: selected ? selectedStyleName : DEFAULT
      }, restButtonProps));
    };
    return buttonWrapperProps ? /*#__PURE__*/React__default.createElement(ButtonWrapper, _extends({
      key: "".concat(button$1.label, "-").concat(i)
    }, buttonWrapperProps), /*#__PURE__*/React__default.createElement(ButtonComponent, null)) : /*#__PURE__*/React__default.createElement(ButtonComponent, {
      key: "".concat(button$1.label, "-").concat(i)
    });
  });
  return /*#__PURE__*/React__default.createElement(buttonGroup_style.ButtonGroupWrapper, _extends({
    inline: inline,
    overflow: overflow
  }, combinedDataAttr, otherProps), buttonGroupButtons);
};
const ButtonGroupPattern = styled.withTheme(ButtonGroup);

exports.ButtonWrapper = ButtonWrapper;
exports.default = ButtonGroupPattern;
